<section class="toggle-form" [ngClass]="{ active: isDelegateSliderOpen }">
    <div class="formwrap">
      <div class="Header">
        <h2>
          <b>{{ topBarTitle }}</b>
        </h2>
        <p-button
        appPreventDoubleClick
          styleClass="p-button-text"
          id="delegateSliderCloseButton"
          type="button"
          label="Close"
          (debounceClick)="closeSlider()"
        ></p-button>
      </div>
      <div class="general-container">
        <p-tabView [(activeIndex)]="activeTab" >
          <p-tabPanel  header="Delegation" [rightIcon]="errorIconClassForTab">
            <div class="content">
              <app-delegation-creation #delegateComponent [isDelegateSliderOpenedFromDocumentDetailPage]="isDelegateSliderOpenedFromDocumentDetailPage" 
                                        [documentNumber]="documentNumber" (activateTabIndex)="openCurrentTab($event)"></app-delegation-creation>
            </div>
          </p-tabPanel>
          <p-tabPanel header="Linked Items" [disabled]="!isLinkedItemsSlider">
            <app-delegation-linked-items (sendLinkedItemsData)="delegateComponent.saveDelegateWithLinkedItems($event)" (activateTabIndex)="openCurrentTab($event)"> </app-delegation-linked-items>
          </p-tabPanel>
        </p-tabView>
      </div>
    </div>
  </section>
  